// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SwitchContentButton Styles */

.scl--web-component-switch-content-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  width: 100%;
}

/* Each accordion item */
.scl--web-component-switch-content-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-bottom: 14px;
  width: 100%;
  align-self: stretch;
  cursor: pointer;
  user-select: none;
}

/* Separator line container */
.scl--web-component-switch-content-separator {
  width: 100%;
  height: 0;
}

/* Default separator line - uses background instead of border for smooth transition */
.scl--web-component-switch-content-line {
  position: relative;
  width: 100%;
  height: 3px;
  background: rgba(0, 0, 0, 0.1);
  transition: height 0.2s ease, background 0.3s ease;
}

/* Gradient overlay via ::after pseudo-element (opacity is animatable, border-image is not) */
.scl--web-component-switch-content-line::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, rgba(255, 3, 7, 0.6) 0%, rgba(246, 6, 207, 0.6) 44.61%, rgba(0, 109, 217, 0.6) 100%);
  opacity: 0;
  transition: opacity 0.2s ease ;
}
.scl--web-component-switch-content-item:hover .scl--web-component-switch-content-line{
  background: rgba(0, 0, 0, 0.3);
}
/* Gradient separator line for active item */
.scl--web-component-switch-content-item.active .scl--web-component-switch-content-line {
  height: 5px;
}

.scl--web-component-switch-content-item.active .scl--web-component-switch-content-line::after {
  opacity: 1;
}

/* Row with title and arrow */
.scl--web-component-switch-content-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 14px;
  padding: 0;
  width: 100%;
}

/* Title wrapper */
.scl--web-component-switch-content-title-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 7px 0;
  gap: 10px;
}

/* Title text */
.scl--web-component-switch-content-title {
  font-family: var(--primary-font);
  font-weight: 600;
  font-size: 45px;
  line-height: 53px;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  color: #000000;
}

/* Arrow icon wrapper */
.scl--web-component-switch-content-icon-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 9px 0;
  gap: 10px;
}

/* Arrow icon */
.scl--web-component-switch-content-arrow {
  width: 30px;
  height: 27px;
  transition: transform 0.3s ease;
}

/* Arrow rotated 90deg when active (points down) */
.scl--web-component-switch-content-arrow.rotated {
  transform: rotate(90deg);
}

/* Description wrapper - handles expand/collapse animation */
.scl--web-component-switch-content-description-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding-top: 0;
  padding-bottom: 0;
  width: 100%;
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transform: translateY(-4px);
  transition:
    max-height 0.55s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.35s ease-out,
    transform 0.35s ease-out,
    padding 0.4s ease;
}

/* Expanded description */
.scl--web-component-switch-content-description-wrapper.expanded {
  max-height: 200px;
  opacity: 1;
  transform: translateY(0);
  padding-top: 10px;
}

/* Description text */
.scl--web-component-switch-content-description {
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;

  font-size: 18px;
  line-height: 25px;
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.6);
  margin: 0;
  width: 100%;
}

/* Responsive - 850px: No animation, show description by default */
@media screen and (max-width: 850px) {
  .scl--web-component-switch-content-description-wrapper {
    max-height: none;
    opacity: 1;
    transform: none;
    overflow: visible;
    transition: none;
    padding-top: 0;
  }

  .scl--web-component-switch-content-description-wrapper.expanded {
    max-height: none;
    padding-top: 0;
  }

  /* Hide description for non-active items */
  .scl--web-component-switch-content-item:not(.active) .scl--web-component-switch-content-description-wrapper {
    display: none;
  }

  /* Show description only for active item */
  .scl--web-component-switch-content-item.active .scl--web-component-switch-content-description-wrapper {
    display: flex;
  }
}

/* Responsive - 500px: Same as 850px */
@media screen and (max-width: 500px) {
  .scl--web-component-switch-content-description-wrapper {
    max-height: none;
    opacity: 1;
    transform: none;
    overflow: visible;
    transition: none;
    padding-top: 0;
  }

  .scl--web-component-switch-content-description-wrapper.expanded {
    max-height: none;
    padding-top: 0;
  }

  /* Hide description for non-active items */
  .scl--web-component-switch-content-item:not(.active) .scl--web-component-switch-content-description-wrapper {
    display: none;
  }

  /* Show description only for active item */
  .scl--web-component-switch-content-item.active .scl--web-component-switch-content-description-wrapper {
    display: flex;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component-module/component-services/button/switch-round-button/css/switchContentButton.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,SAAS;AACX;;AAEA,qFAAqF;AACrF;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,kDAAkD;AACpD;;AAEA,6FAA6F;AAC7F;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uHAAuH;EACvH,UAAU;EACV,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA,4CAA4C;AAC5C;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,UAAU;EACV,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA,eAAe;AACf;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA,eAAe;AACf;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA,kDAAkD;AAClD;EACE,wBAAwB;AAC1B;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,2BAA2B;EAC3B;;;;qBAImB;AACrB;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,UAAU;EACV,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;;EAEhB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,WAAW;AACb;;AAEA,kEAAkE;AAClE;EACE;IACE,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA,0CAA0C;EAC1C;IACE,aAAa;EACf;;EAEA,0CAA0C;EAC1C;IACE,aAAa;EACf;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA,0CAA0C;EAC1C;IACE,aAAa;EACf;;EAEA,0CAA0C;EAC1C;IACE,aAAa;EACf;AACF","sourcesContent":["/* SwitchContentButton Styles */\n\n.scl--web-component-switch-content-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0;\n  width: 100%;\n}\n\n/* Each accordion item */\n.scl--web-component-switch-content-item {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding-bottom: 14px;\n  width: 100%;\n  align-self: stretch;\n  cursor: pointer;\n  user-select: none;\n}\n\n/* Separator line container */\n.scl--web-component-switch-content-separator {\n  width: 100%;\n  height: 0;\n}\n\n/* Default separator line - uses background instead of border for smooth transition */\n.scl--web-component-switch-content-line {\n  position: relative;\n  width: 100%;\n  height: 3px;\n  background: rgba(0, 0, 0, 0.1);\n  transition: height 0.2s ease, background 0.3s ease;\n}\n\n/* Gradient overlay via ::after pseudo-element (opacity is animatable, border-image is not) */\n.scl--web-component-switch-content-line::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, rgba(255, 3, 7, 0.6) 0%, rgba(246, 6, 207, 0.6) 44.61%, rgba(0, 109, 217, 0.6) 100%);\n  opacity: 0;\n  transition: opacity 0.2s ease ;\n}\n.scl--web-component-switch-content-item:hover .scl--web-component-switch-content-line{\n  background: rgba(0, 0, 0, 0.3);\n}\n/* Gradient separator line for active item */\n.scl--web-component-switch-content-item.active .scl--web-component-switch-content-line {\n  height: 5px;\n}\n\n.scl--web-component-switch-content-item.active .scl--web-component-switch-content-line::after {\n  opacity: 1;\n}\n\n/* Row with title and arrow */\n.scl--web-component-switch-content-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 14px;\n  padding: 0;\n  width: 100%;\n}\n\n/* Title wrapper */\n.scl--web-component-switch-content-title-wrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 7px 0;\n  gap: 10px;\n}\n\n/* Title text */\n.scl--web-component-switch-content-title {\n  font-family: var(--primary-font);\n  font-weight: 600;\n  font-size: 45px;\n  line-height: 53px;\n  letter-spacing: 1px;\n  display: flex;\n  align-items: center;\n  color: #000000;\n}\n\n/* Arrow icon wrapper */\n.scl--web-component-switch-content-icon-wrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 9px 0;\n  gap: 10px;\n}\n\n/* Arrow icon */\n.scl--web-component-switch-content-arrow {\n  width: 30px;\n  height: 27px;\n  transition: transform 0.3s ease;\n}\n\n/* Arrow rotated 90deg when active (points down) */\n.scl--web-component-switch-content-arrow.rotated {\n  transform: rotate(90deg);\n}\n\n/* Description wrapper - handles expand/collapse animation */\n.scl--web-component-switch-content-description-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding-top: 0;\n  padding-bottom: 0;\n  width: 100%;\n  max-height: 0;\n  overflow: hidden;\n  opacity: 0;\n  transform: translateY(-4px);\n  transition:\n    max-height 0.55s cubic-bezier(0.4, 0, 0.2, 1),\n    opacity 0.35s ease-out,\n    transform 0.35s ease-out,\n    padding 0.4s ease;\n}\n\n/* Expanded description */\n.scl--web-component-switch-content-description-wrapper.expanded {\n  max-height: 200px;\n  opacity: 1;\n  transform: translateY(0);\n  padding-top: 10px;\n}\n\n/* Description text */\n.scl--web-component-switch-content-description {\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 400;\n\n  font-size: 18px;\n  line-height: 25px;\n  display: flex;\n  align-items: center;\n  color: rgba(0, 0, 0, 0.6);\n  margin: 0;\n  width: 100%;\n}\n\n/* Responsive - 850px: No animation, show description by default */\n@media screen and (max-width: 850px) {\n  .scl--web-component-switch-content-description-wrapper {\n    max-height: none;\n    opacity: 1;\n    transform: none;\n    overflow: visible;\n    transition: none;\n    padding-top: 0;\n  }\n\n  .scl--web-component-switch-content-description-wrapper.expanded {\n    max-height: none;\n    padding-top: 0;\n  }\n\n  /* Hide description for non-active items */\n  .scl--web-component-switch-content-item:not(.active) .scl--web-component-switch-content-description-wrapper {\n    display: none;\n  }\n\n  /* Show description only for active item */\n  .scl--web-component-switch-content-item.active .scl--web-component-switch-content-description-wrapper {\n    display: flex;\n  }\n}\n\n/* Responsive - 500px: Same as 850px */\n@media screen and (max-width: 500px) {\n  .scl--web-component-switch-content-description-wrapper {\n    max-height: none;\n    opacity: 1;\n    transform: none;\n    overflow: visible;\n    transition: none;\n    padding-top: 0;\n  }\n\n  .scl--web-component-switch-content-description-wrapper.expanded {\n    max-height: none;\n    padding-top: 0;\n  }\n\n  /* Hide description for non-active items */\n  .scl--web-component-switch-content-item:not(.active) .scl--web-component-switch-content-description-wrapper {\n    display: none;\n  }\n\n  /* Show description only for active item */\n  .scl--web-component-switch-content-item.active .scl--web-component-switch-content-description-wrapper {\n    display: flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
